import React from "react";

const LOGO_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_techmate-security/artifacts/b9qrppi3_Techmate%20Logo.png";

export const LogoMark = ({ size = 176, className = "" }) => (
  <img
    src={LOGO_URL}
    alt="Techmate Infosec Solutions logo"
    width={size}
    height={size}
    className={`shield-pulse object-contain ${className}`}
    style={{ height: size, width: size, marginLeft: -Math.round(size * 0.06), marginRight: -Math.round(size * 0.06) }}
    loading="eager"
    fetchPriority="high"
  />
);

/**
 * Logo — extra-large brand mark sized to visually match the two-line wordmark.
 * PNG has ~15% transparent padding on each side, so container is oversized.
 */
export const Logo = ({ compact = false, className = "" }) => {
  const size = compact ? 128 : 180;
  return (
    <div className={`flex items-center gap-3 sm:gap-4 ${className}`} data-testid="techmate-logo">
      <LogoMark size={size} className="drop-shadow-md" />
      <div className="text-center">
        <div
          className={`font-display ${compact ? "text-[30px]" : "text-[38px] sm:text-[46px] lg:text-[50px]"} font-black tracking-tight whitespace-nowrap leading-none`}
          style={{
            background: "linear-gradient(90deg, #0F4C81 0%, #38BDF8 55%, #F97316 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            letterSpacing: "-0.02em",
          }}
        >
          TECHMATE
        </div>
        <div className={`mt-2 ${compact ? "text-[11px]" : "text-[12px] sm:text-[14px]"} font-bold uppercase tracking-[0.34em] text-primary text-center`}>
          Infosec Solutions
        </div>
      </div>
    </div>
  );
};

export default Logo;
